import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'js-cookie';

export const initialState = {
  currentLang: `${Cookies.get("language") || (localStorage.getItem("lang") || "fr")}`,
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    updateCurrentLang: (state: { currentLang: string }, action) => ({ currentLang: action.payload }),
  },
});

export const languageActions = languageSlice.actions;

export default languageSlice.reducer;
